import React from "react";
import styles from "./RadioButton.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
  label?: string;
  checked?: boolean;
  onChange?: (value: string) => void;
  value?: string;
  name?: string;
  id?: string;
}

const RadioButton: React.FC<Props> = ({
  label,
  checked = false,
  onChange,
  value,
  id,
}) => {
  const { t } = useTranslation();
  const radioId = id || `radio-${Math.random().toString(36).substr(2, 9)}`;

  const handleClick = () => {
    if (onChange && value) {
      onChange(value);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div className={styles["container"]}>
      <div
        className={`${styles["radio-dot"]} ${checked ? styles["checked"] : ""}`}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="radio"
        aria-checked={checked}
        aria-labelledby={`${radioId}-label`}>
        {checked && <div className={styles["inner-dot"]} />}
      </div>
      <label
        id={`${radioId}-label`}
        className={styles["label"]}
        onClick={handleClick}
        htmlFor={radioId}>
        {label ? t(label) : ""}
      </label>
    </div>
  );
};

RadioButton.displayName = "RadioButton";

export default RadioButton;
